"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Form = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Form"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var styles = {
  "modal": "modal_GLh2iu",
  "header": "header_2q2NtG",
  "body": "body_1Vs0Wn",
  "footer": "footer_1aulnD",
  "title": "title_hO6HwL"
}; 
require('./FormModal.css');
var FormModal = function FormModal(props) {
  var title = props.title,
    body = props.body,
    cancelButtonText = props.cancelButtonText,
    submitButtonText = props.submitButtonText,
    disableSubmitButton = props.disableSubmitButton,
    disableText = props.disableText,
    isDanger = props.isDanger,
    isLoading = props.isLoading,
    onCancel = props.onCancel,
    onChange = props.onChange,
    form = props.form,
    onSubmit = props.onSubmit,
    className = props.className,
    testId = props.testId;
  var labelId = 'form-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    onEsc: onCancel,
    onClickOverlay: onCancel,
    className: (0, _classnames.default)(className, styles.modal),
    ariaLabelledBy: labelId,
    role: isDanger ? 'alertdialog' : 'dialog'
  }, /*#__PURE__*/_react.default.createElement(_Form.default, {
    onSubmit: onSubmit,
    onChange: onChange,
    value: form,
    testId: "".concat(testId, "-form")
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    testId: "form-modal-header",
    className: styles.header,
    isDanger: isDanger
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: labelId,
    className: styles.title
  }, title)), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    className: styles.body,
    testId: "form-modal-body"
  }, body), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "form-modal-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "form-modal-cancel-button",
    kind: "tertiary",
    onClick: onCancel,
    disabled: isLoading,
    noFill: true
  }, cancelButtonText), /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "form-modal-submit-button",
    kind: isDanger ? 'danger' : 'primary',
    type: "submit",
    isLoading: isLoading,
    disabled: isLoading || disableSubmitButton
  }, disableSubmitButton ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: disableText
  }, submitButtonText) : submitButtonText))));
};
FormModal.defaultProps = {
  cancelButtonText: 'Cancel',
  className: null,
  isDanger: false,
  isLoading: false,
  disableSubmitButton: false,
  disableText: null,
  submitButtonText: 'Submit',
  testId: 'modal'
};
var _default = exports.default = FormModal;
//# sourceMappingURL=FormModal.js.map